function initMobileSlider() {
  if ($(window).width() < 768) {
    if (!$('.home-shop-wrap').hasClass('slick-initialized')) {
      $('.home-shop-wrap').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: true ,
          autoplay: true,
        autoplaySpeed: 4000,
        speed: 600 ,
         centerMode: true,
        centerPadding: '40px'
      });
    }
  } else {
    if ($('.home-shop-wrap').hasClass('slick-initialized')) {
      $('.home-shop-wrap').slick('unslick');
    }
  }
}

// On page load
$(document).ready(function () {
  initMobileSlider();
});

// On resize
$(window).on('resize', function () {
  initMobileSlider();
});




   $(document).ready(function(){
        $('.testimonial_slider_code').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          speed: 300,
          infinite: false, 
          prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
          autoplaySpeed: 5000,
          autoplay: true,
          responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
          
      ]
        });
      });
